import mixitup from 'mixitup';
import mixitupMultifilter from '../vendor/mixitup-multifilter';
import mixitupPagination from '../vendor/mixitup-pagination';
import Datepicker from 'vanillajs-datepicker/Datepicker';
import nl from 'vanillajs-datepicker/locales/nl';
import FilterState from './FilterState';
Object.assign(Datepicker.locales, nl);

export default class ArticleFilter {
	constructor($articlefilter) {

		this.filterContainer = $articlefilter;
		this.cardsContainer = document.querySelector('[data-card-container]');
		this.checkedInputs = null;

		this.cardSelector = '.c-card-article';
		this.originalCollection = this.cardsContainer.querySelectorAll(this.cardSelector);
		this.resetBtns = document.querySelectorAll('[data-reset-filter]');

		this.resetBtns.forEach((btn) => {
			btn.addEventListener('click', this.resetFilters.bind(this));
		});

		this.filterContainer.addEventListener('change', this.filter.bind(this));

		new FilterState(this.filterContainer);

		this.startDateInput = this.filterContainer.querySelector('[data-start-date]');
        this.endDateInput = this.filterContainer.querySelector('[data-end-date]');

        const datepickerSettings = {
            language: 'nl',
            clearBtn: true,
            maxDate: new Date(),
            autohide: true,
            nextArrow: '<svg class="icon icon-icon-arrow_right"><use xlink:href="#icon-icon-arrow_right"></use></svg>',
            prevArrow: '<svg class="icon icon-icon-arrow_left"><use xlink:href="#icon-icon-arrow_left"></use></svg>'
        };

		const event = new Event('change');

        this.startDatePicker = new Datepicker(this.startDateInput, datepickerSettings);
        this.startDateInput.addEventListener('changeDate', () => {
			this.filterContainer.dispatchEvent(event)
		});

        this.endDatePicker = new Datepicker(this.endDateInput, datepickerSettings);
        this.endDateInput.addEventListener('changeDate', () => {
			this.filterContainer.dispatchEvent(event)
		});

		mixitup.use(mixitupMultifilter);
		mixitup.use(mixitupPagination);

		this.mixer = mixitup(this.cardsContainer, {
			selectors: {
				target: this.cardSelector,
			},
			animation: {
				duration: 400,
				queueLimit: 5,
				effects: 'fade translateY(100px)',
			},
			multifilter: {
				enable: true,
			},
            pagination: {
                limit: 10,
				hidePageListIfSinglePage: true,
            },
			templates: {
				pagerPrev: '<div class="page-nav"><button type="button" class="${classNames} page-navbtn" data-page="prev"><svg class="icon icon-icon-arrow_left"><use xlink:href="#icon-icon-arrow_left"></use></svg><span>Vorige pagina</span></button></div>',
				pagerNext: '<div class="page-nav page-nav--right"><button type="button" class="${classNames} page-navbtn" data-page="next"><span>Volgende pagina</span><svg class="icon icon-icon-arrow_right"><use xlink:href="#icon-icon-arrow_right"></use></svg></button></div>',
				pager: '<button type="button" class="${classNames} page-stat" data-page="${pageNumber}">${pageNumber}</button>',
			},
			load: {
				filter: 'none',
			},
			callbacks: {
				onPaginateStart: () => {
					setTimeout(() => {
						window.scrollTo({ top: 0, behavior: 'smooth' });
					}, 100);
				}
			}
		});

		this.filter(true);
	}

	resetFilters() {
		this.checkedInputs.forEach((checkedInput) => {
			checkedInput.checked = false;
		});

        this.startDateInput.value = '';
        this.endDateInput.value = '';

		const event = new Event('change');
		this.filterContainer.dispatchEvent(event)

	}

	filter() {
		this.checkedInputs = this.filterContainer.querySelectorAll(':checked');

		let selector = this.cardSelector;

		// custom selector based on checked inputs
		if (this.checkedInputs.length) {
			selector = '';

			this.checkedInputs.forEach(input => {
                if (selector.length <= 0) {
                    selector = `.${input.value}`;
                } else {
                    selector = `${selector}, .${input.value}`;
                }
			});
		}

		// collection cards with the default selector or based on custom selector
		this.collectionCards = this.cardsContainer.querySelectorAll(selector);

        if (this.startDateInput.value) {
            this.startDate = this.startDatePicker.getDate();
            const cardArray = [...this.collectionCards].filter((element) => {
                const cardDate = new Date(element.dataset.date);
                return cardDate >= this.startDate;
            });
            this.collectionCards = cardArray;
        }

        if (this.endDateInput.value) {
            this.endDate = this.endDatePicker.getDate();
            const cardArray = [...this.collectionCards].filter((element) => {
                const cardDate = new Date(element.dataset.date);
                return cardDate <= this.endDate;
            });
            this.collectionCards = cardArray;
        }

		this.mixer.filter(this.collectionCards);

		let itemCount = this.collectionCards.length;
		this.failMessage = document.querySelector('[data-fail-message]');

		if (itemCount <= 0) {
			this.failMessage.style.display = 'block';
		} else {
			this.failMessage.style.display = 'none';
		}
	}
}
